import { Spacing, SpacingSizes } from "@components/Spacing";
import { useProjectedChart } from "@hooks";
import { Translations, i18n } from "@i18n";
import { InvestedReturns } from "./InvestedReturns";
import { TimeFrame } from "./TimeFrame";
import { TimePassed } from "./TimePassed";
import { styles } from "./styles";
import { ChartFooterProps } from "./types";

export const ChartFooter = ({
  initialLabel = i18n.t(Translations.ProjectedChartFooterToday),
  projectedLabel: projectedLabelProp,
}: ChartFooterProps) => {
  const { targetYear } = useProjectedChart();

  const projectedLabel = projectedLabelProp ?? targetYear;

  return (
    <div>
      <div style={styles.container}>
        <TimeFrame>{initialLabel}</TimeFrame>
        <TimePassed />
        <TimeFrame>{projectedLabel}</TimeFrame>
      </div>
      <Spacing size={SpacingSizes.XS} />
      <InvestedReturns />
    </div>
  );
};
